import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import UserPane from '../../user/containers/Pane'
import ReleasePane from '../../release/containers/Pane'
import MuseumPane from '../../museum/containers/Pane'
import ProgramPane from '../../program/containers/Pane'
import GuidedTourPane from '../../guided-tour/containers/Pane'

@inject('auth') @observer
export default class IndexPage extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      user: PropTypes.object
    }).isRequired,
  }

  render() {

    if (!this.props.auth.user) {
      return null
    }

    let panes = [
      { name: 'MuseumPane', Comp: MuseumPane },
      { name: 'ProgramPane', Comp: ProgramPane },
      { name: 'GuidedTourPane', Comp: GuidedTourPane }
    ]

    if (this.props.auth.user.isAdmin) {
      panes = [
        { name: 'UserPane', Comp: UserPane },
        { name: 'ReleasePane', Comp: ReleasePane }
      ]
    }
    return (
      <section className="app-panes panes stretch horizontal">
        {panes.map(({ name, Comp }) => (
          <Comp
            key={name}
            params={this.props.params}
          />
        ))}
      </section>
    )
  }

}



// WEBPACK FOOTER //
// ./src/base/components/IndexPage.js